(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("FEGORender"), require("FEGOEditor"));
	else if(typeof define === 'function' && define.amd)
		define(["FEGORender", "FEGOEditor"], factory);
	else if(typeof exports === 'object')
		exports["/fego/component/quotes-chart/render"] = factory(require("FEGORender"), require("FEGOEditor"));
	else
		root["/fego/component/quotes-chart/render"] = factory(root["FEGORender"], root["FEGOEditor"]);
})(self, (__WEBPACK_EXTERNAL_MODULE__5322__, __WEBPACK_EXTERNAL_MODULE__4183__) => {
return 